import { render, staticRenderFns } from "./UserFormSettings.vue?vue&type=template&id=08ebf50f&"
import script from "./UserFormSettings.vue?vue&type=script&lang=js&"
export * from "./UserFormSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports